define((require) => {
    "use strict";

    const Backbone             = require("backbone");
    const CompositeWidgetModel = require("shared/ui/experience/widgets/compositeWidget/CompositeWidgetModel");
    const WidgetCollection     = require("shared/ui/experience/widgets/WidgetCollection");
    const Scale                = require("shared/util/Scale");
    const ImprovedModel        = require("shared/zbone/ImprovedModel");

    /**
     * A scene (model) in an experience.
     *
     * @author Gorm Casper
     * @author Bo Gotthardt
     *
     * @class Scene
     */
    return ImprovedModel.extend("Scene", {

        relations: [{
            type: Backbone.Many,
            key: "widgets",
            collectionType: WidgetCollection,
            // TODO: Investigate whether this is still needed/used. Should be removed...
            reverseRelation: {
                key: "scene"
            }
        }],

        defaults: {
            sceneNumber: null,

            widgets: [],

            widgetTabOrder: null,

            removedWidgetTabOrder: null,

            /**
             * Represents the current scale of the scene.
             *
             * Setting the scale will affect the contained widget
             * model's scale.
             *
             * Note that this is a transient property.
             *
             * @type {Scale}
             */
            scale: new Scale()
        },

        computed: {
            isOverlayScene: {
                deps: ["sceneNumber"],
                value(sceneNumber) {
                    return sceneNumber === "overlay";
                }
            },
            isBackgroundScene: {
                deps: ["sceneNumber"],
                value(sceneNumber) {
                    return sceneNumber === "background";
                }
            }
        },

        transient: ["widgetTabOrderMetaData", "removedWidgetTabOrderMetaData"],

        /**
         * Constructor.
         */
        constructor() {
            this.__super();

            // Delegate the scale to the contained widget models
            this.listenTo(this, "change:scale", (model, scale) => {
                this.get("widgets").invoke("set", "scale", scale);
            });
        },

        _distinguishedName() {
            const sceneNumber = this.get("sceneNumber");
            const name = "Scene";

            return sceneNumber ? `${name} ${sceneNumber}` : name;
        },

        // sceneNumber is a string, while this will return a number and set index to 0 for overlay and background scenes
        getSceneIndex() {
            return parseInt(this.get("sceneNumber"), 10);
        },

        widgetsByClass(widgetClass) {
            const widgets = this.get("widgets");

            if (widgets) {
                // all widgets include grouped widgets
                let allWidgets = [];

                widgets.each((widget) => {
                    if (widget instanceof CompositeWidgetModel) {
                        const groupedWidgets = widget.get("group");
                        allWidgets = allWidgets.concat(groupedWidgets.models);
                    } else {
                        allWidgets.push(widget);
                    }
                });

                return allWidgets.filter((widget) => widget instanceof widgetClass);
            }

            return [];
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/Scene.js